/* eslint-disable max-len */
import React, { useState } from 'react';
import { Form, Formik } from 'formik';
import { useTranslation } from 'react-i18next';
import { CommonDatePicker, RegularButton, CommonInput } from 'pg-ui-library';

/* import { ReactComponent as EditSvg } from 'src/assets/edit-white.svg'; */

import { useTypedSelector } from 'src/hooks/useTypedSelector';
import { downloadCSV } from 'src/utils/csvConverter';
import { IEmployeeForm } from '../..';
import { Header, InputWrapper, TabWrapper } from './styles';

const PersonalInformationTab: React.FC = () => {
  const { employee } = useTypedSelector(state => state.employees.data.selectedEmployee);
  const [editMode] = useState<boolean>(true);
  /*
  const handleEdit = (value: boolean) => {
    setEditMode(!value);
  };
  */

  const exportToExcel = (): void => {
    downloadCSV([employee], employee?.name || 'employee-csv');
  };

  const initialValuesInformation: Partial<IEmployeeForm> = {
    ...employee,
    birthDate: (employee?.birthDate && new Date(employee?.birthDate)) || '',
  };

  // eslint-disable-next-line no-unused-vars
  const onSubmit = async (values: Partial<IEmployeeForm>) => {};

  const { t } = useTranslation();

  return (
    <Formik initialValues={initialValuesInformation} onSubmit={onSubmit}>
      {({ handleChange, values }) => (
        <Form>
          <TabWrapper>
            <Header>
              <span>{t('employeePage.personalTab.information.title')}</span>
              <div>
                <RegularButton onClick={exportToExcel}>{t('global.form.export')}</RegularButton>
                {/*
                <RegularButton onClick={() => handleEdit(editMode)}>
                  <EditSvg />
                  {t('global.form.edit')}
                </RegularButton>
                */}
              </div>
            </Header>
            <InputWrapper>
              <CommonInput
                id="employeeId"
                name="employeeId"
                label={t('employeePage.personalTab.information.employeeId')}
                placeholder="Employee Id"
                value={values.employeeId}
                onChange={handleChange}
                disabled={editMode}
              />
              <CommonInput
                id="firstName"
                name="firstName"
                label={t('employeePage.personalTab.information.firstName')}
                placeholder="First Name"
                value={values.firstName}
                onChange={handleChange}
                disabled={editMode}
              />
              <CommonInput
                id="middleName"
                name="middleName"
                label={t('employeePage.personalTab.information.middleName')}
                placeholder="Middle Name"
                value={values.middleName}
                onChange={handleChange}
                disabled={editMode}
              />
              <CommonInput
                id="lastName"
                name="lastName"
                label={t('employeePage.personalTab.information.lastName')}
                placeholder="Last Name"
                value={values.lastName}
                onChange={handleChange}
                disabled={editMode}
              />
              <CommonInput
                id="ssn"
                name="ssn"
                label={t('employeePage.personalTab.information.ssn')}
                placeholder="SSN"
                value={values.ssn}
                onChange={handleChange}
                disabled={editMode}
              />
              <CommonDatePicker
                id="birthDate"
                name="birthDate"
                label={t('employeePage.personalTab.information.birthDate')}
                onChange={handleChange}
                disabled={editMode}
                placeholderText="MM/DD/YY"
              />
            </InputWrapper>
            <InputWrapper>
              <CommonInput
                id="gender"
                name="gender"
                label={t('employeePage.personalTab.information.gender')}
                placeholder="Gender"
                value={values.gender}
                onChange={handleChange}
                disabled={editMode}
              />
              <CommonInput
                id="maritalStatus"
                name="maritalStatus"
                label={t('employeePage.personalTab.information.maritalStatus')}
                placeholder="Marital Status"
                value={values.maritalStatus}
                onChange={handleChange}
                disabled={editMode}
              />
              <CommonInput
                id="smokerStatus"
                name="smokerStatus"
                label={t('employeePage.personalTab.information.smokerStatus')}
                placeholder="Smoker Status"
                value={values.smokerStatus}
                onChange={handleChange}
                disabled={editMode}
              />
            </InputWrapper>
            <InputWrapper>
              <CommonInput
                id="addressLine1"
                name="addressLine1"
                label={t('employeePage.personalTab.information.addressLine1')}
                placeholder="Address Line 1"
                value={values.addressLine1}
                onChange={handleChange}
                disabled={editMode}
              />
              <CommonInput
                id="addressLine2"
                name="addressLine2"
                label={t('employeePage.personalTab.information.addressLine2')}
                placeholder="Address Line 2"
                value={values.addressLine2}
                onChange={handleChange}
                disabled={editMode}
              />
              <CommonInput
                id="city"
                name="city"
                label={t('employeePage.personalTab.information.city')}
                placeholder="City"
                value={values.city}
                onChange={handleChange}
                disabled={editMode}
              />
              <CommonInput
                id="state"
                name="state"
                label={t('employeePage.personalTab.information.state')}
                placeholder="State"
                value={values.state}
                onChange={handleChange}
                disabled={editMode}
              />
              <CommonInput
                id="zipCode"
                name="zipCode"
                label={t('employeePage.personalTab.information.zipCode')}
                placeholder="Zip Code"
                value={values.zipCode}
                onChange={handleChange}
                disabled={editMode}
              />
              <CommonInput
                id="country"
                name="country"
                label={t('employeePage.personalTab.information.country')}
                placeholder="Country"
                value={values.country}
                onChange={handleChange}
                disabled={editMode}
              />
              <CommonInput
                id="phone1"
                name="phone1"
                label={t('employeePage.personalTab.information.phone1')}
                placeholder="Phone 1"
                value={values.phone1}
                onChange={handleChange}
                disabled={editMode}
              />
              <CommonInput
                id="phone2"
                name="phone2"
                label={t('employeePage.personalTab.information.phone2')}
                placeholder="Phone 2"
                value={values.phone2}
                onChange={handleChange}
                disabled={editMode}
              />
            </InputWrapper>
          </TabWrapper>
        </Form>
      )}
    </Formik>
  );
};

export default PersonalInformationTab;
